export default "__VITE_ASSET__DEphg4qy__"